import { Link, Typography } from '@mui/material';
import React, { PropsWithChildren } from 'react';
import { SearchDrawerContainer } from '../../areas/ranked-search/components/search-drawer/search-drawer-container';
import { useAuthenticatedUser } from '../../authentication';
import { useTenantConfiguration } from '../../hooks/use-tenant-configuration';
import { AppHeader } from '../app-header';
import { CssBaseDecorator } from '../cssbasedecorator';
import './layout.scss';
import { MainNavigation } from './main-navigation/main-navigation';
import { useRoleThemes } from '../../authentication/use-role-themes';
import { useFeatureToggles } from '../../feature-toggles/feature-toggles';
import { EMPLOYEE_CPR_TOGGLE } from '../../areas/admin/organization/users/employee-cpr';
import { getEditUserPath } from '../../areas/admin/organization/organization-pathnames';
import { LogoutButton } from '../../authentication/logout-button';

export function RootLayout(props: PropsWithChildren<Record<string, unknown>>) {
  const { children } = props;

  return (
    <CssBaseDecorator>
      <div className="layout__container">{children}</div>
    </CssBaseDecorator>
  );
}

export function DefaultLayout(props: PropsWithChildren<Record<string, unknown>>) {
  const { children } = props;
  const user = useAuthenticatedUser();
  const { isFeatureEnabled } = useFeatureToggles();

  const tenantDisplayConfiguration = useTenantConfiguration();
  const { tenantDisplayName } = tenantDisplayConfiguration;

  const { isOnlyServiceProvider, isOnlyMedicalCollaborator } = useRoleThemes();

  return (
    <RootLayout>
      <div className="layout__main-navigation">
        <MainNavigation />
      </div>
      <div className="layout__app-header">
        <AppHeader actions={isFeatureEnabled('UseApexStsLogin_EnableJdcLogout') && <LogoutButton />}>
          <div style={{ marginRight: '10px' }}>
            {isFeatureEnabled(EMPLOYEE_CPR_TOGGLE) && user?.profile?.id ? (
              <Link href={getEditUserPath(user.profile.id)} target="_blank" rel="noopener noreferrer" color="inherit" underline="hover" title="Gå til din bruger">
                {user.profile.name}
              </Link>
            ) : (
              user && user.profile && user.profile.name
            )}
            <br />
            <Typography style={{ fontSize: '12px' }}>{tenantDisplayName}</Typography>
          </div>
        </AppHeader>
      </div>
      <div className="layout__content">{children}</div>
      {!isOnlyServiceProvider && !isOnlyMedicalCollaborator && <SearchDrawerContainer />}
    </RootLayout>
  );
}

export function StandaloneLayout(props: PropsWithChildren<Record<string, unknown>>) {
  const { children } = props;

  return (
    <RootLayout>
      <div className="layout__content">{children}</div>
    </RootLayout>
  );
}
